import React from 'react';
import { styled } from '@linaria/react';

import SquigglyLine from '@/components/SquigglyLine';
import { BaseWrapper as AsideWrapper } from '@/components/Aside';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  width?: number;
  height?: number;
}

function Divider({
  width = 100,
  height = 50,
  style = {},
  ...delegated
}: Props) {
  return (
    <Wrapper
      {...delegated}
      style={{
        ...style,
        maxWidth: width,
      }}
    >
      <SquigglyLine
        width={width}
        height={height}
        squiggleWidth={10}
        stroke="var(--color-secondary)"
        strokeWidth={2}
      />
    </Wrapper>
  );
}

export default Divider;

const Wrapper = styled.div`
  margin: 32px auto 48px;

  ${AsideWrapper} & {
    margin: 16px auto 24px;
  }
`;
